module.exports = __webpack_public_path__ + "static/icon-presentation-cd77d45ebf617ec4340ddef7dba5dc3c.png";